import React from "react"
import { MainCP } from "../../Components/evaluacionPaisTrasGobiernoMarzo2024/MainCP"

const ViewEvaluacionPaisGobiernosMarzo2024: React.FC = () => <MainCP/>

export default ViewEvaluacionPaisGobiernosMarzo2024